var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayMidnightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.268C31.3333 17.0378 31.3333 18.9622 30 19.732L12.75 29.6913C11.4167 30.4611 9.75 29.4989 9.75 27.9593L9.75 8.04071C9.75 6.5011 11.4167 5.53886 12.75 6.30866L30 16.268Z",
    fill: "#241D6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMidnightBlue);
export default __webpack_public_path__ + "static/media/play-midnight-blue.8bdc4318370a8a4207129a4bdefbc3a3.svg";
export { ForwardRef as ReactComponent };